export const ChevronRightSmall = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.3335 13.3332L11.0776 10.5891C11.403 10.2637 11.403 9.73602 11.0776 9.41058L8.3335 6.6665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronRightSmall
